import {useCallback, useMemo} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';

export interface RecruitmentResultsPresentedEventParams {
  recruitment_search_id: string;
  recruitment_screen_name: string;
  item_position: string;
  item_identifier: string;
  creator_id: string;
  campaign_id?: string;
  result_source?: string;
}

function useTrackRecruitmentResultsPresented() {
  const presented = useCallback(
    ({
      recruitment_search_id,
      recruitment_screen_name,
      item_position,
      item_identifier,
      creator_id,
      campaign_id = '',
      result_source = '',
    }: RecruitmentResultsPresentedEventParams) => {
      const recruitmentSearchFlow = AnalyticsService.getOrCreateFlow(
        FLOW_NAMES.RECRUITMENT_SEARCH
      );
      AnalyticsService.dispatchEvent(eventNames.RECRUITMENT_RESULTS_PRESENTED, {
        flow_id: recruitmentSearchFlow.flow_id,
        screen_presentation_id: recruitmentSearchFlow.screen_presentation_id,
        recruitment_search_id,
        recruitment_screen_name,
        item_position,
        item_identifier,
        creator_id,
        campaign_id,
        result_source,
      });
    },
    []
  );

  return useMemo(() => ({presented}), [presented]);
}

export default useTrackRecruitmentResultsPresented;
